"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ProblemBanner = require("./ProblemBanner");
Object.keys(_ProblemBanner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProblemBanner[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProblemBanner[key];
    }
  });
});